function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 2v6H2v2h6v6h2v-6h6V8h-6V2H8" fillRule="evenodd" /></svg>;
});